import { render, staticRenderFns } from "./listPositionTag.vue?vue&type=template&id=e8c218e2&"
import script from "./listPositionTag.vue?vue&type=script&lang=js&"
export * from "./listPositionTag.vue?vue&type=script&lang=js&"
import style0 from "./listPositionTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports